import { render, staticRenderFns } from "./MigrationsPage.vue?vue&type=template&id=27832439&scoped=true&lang=pug"
import script from "./MigrationsPage.vue?vue&type=script&lang=js"
export * from "./MigrationsPage.vue?vue&type=script&lang=js"
import style0 from "./MigrationsPage.vue?vue&type=style&index=0&id=27832439&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27832439",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27832439')) {
      api.createRecord('27832439', component.options)
    } else {
      api.reload('27832439', component.options)
    }
    module.hot.accept("./MigrationsPage.vue?vue&type=template&id=27832439&scoped=true&lang=pug", function () {
      api.rerender('27832439', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/migrations/MigrationsPage.vue"
export default component.exports